import { render, staticRenderFns } from "./ManejoReclamos.vue?vue&type=template&id=52789467"
import script from "./ManejoReclamos.vue?vue&type=script&lang=js"
export * from "./ManejoReclamos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports